import { Login } from "@mui/icons-material";
import { ButtonProps } from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { format, parseISO } from "date-fns";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { CountUp } from "../../../components/CountUp";
import { Dialog } from "../../../components/Dialog";
import { Table } from "../../../components/Table";

type DialogDetailsProps = {
  data: any[];
  open: boolean;
  onClose: () => void;
};

export function DialogDetails({ data, open, onClose }: DialogDetailsProps) {
  const navigate = useNavigate();

  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Fechar",
        onClick: onClose,
      },
    ];
  }, [onClose]);

  const handleNavigateToDetails = useCallback(
    (item: any) => {
      navigate(`/people/${item.id_pessoa}`, { state: item });
    },
    [navigate]
  );

  return (
    <Dialog
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      title="Clientes que compraram durante as campanhas"
      open={open}
      actions={actions}
    >
      <Table
        toolbar={false}
        columnsButton
        pageSize={4}
        columns={[
          { title: "Nome", field: "nome_pessoa" },
          {
            title: "Quantidade de compras",
            field: "TOTAL_CUPOM",
            render: (row) => (
              <CountUp end={Number(row?.TOTAL_CUPOM)} start={0} />
            ),
          },
          {
            title: "Valor total",
            field: "TOTAL",
            render: (row) => (
              <CountUp
                end={Number(row?.TOTAL)}
                prefix="R$"
                decimals={2}
                start={0}
              />
            ),
          },
          {
            title: "Data da última compra",
            field: "DT_ULTIMA_COMPRA",
            render: (row) =>
              format(
                parseISO(row?.DT_ULTIMA_COMPRA?.replace("Z", "")),
                "dd/MM/yyyy HH:mm"
              ),
          },
          {
            title: "Data da recuperação",
            field: "DT_RECUPERACAO",
            render: (row) =>
              format(
                parseISO(row?.DT_ULTIMA_COMPRA?.replace("Z", "")),
                "dd/MM/yyyy HH:mm"
              ),
          },
          {
            title: "Período sem compras",
            field: "dias_ultima_compra",
            render: (row) => (
              <CountUp end={Number(row?.dias_ultima_compra)} start={0} />
            ),
          },
          {
            title: "Ações",
            align: "center",
            render: (row) => (
              <Tooltip title="Ver detalhes" placement="top">
                <IconButton onClick={() => handleNavigateToDetails(row)}>
                  <Login />
                </IconButton>
              </Tooltip>
            ),
          },
        ]}
        data={data}
      />
    </Dialog>
  );
}
